import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api";

export default function EditCaseStudyPractice() {
  const { id } = useParams();
  const nav = useNavigate();

  const [title, setTitle] = useState("");
  const [duration, setDuration] = useState(30);
  const [allCaseStudies, setAllCaseStudies] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    api.get(`/admin/case-study-practice/${id}/view`)
      .then(res => {
        setTitle(res.data.title);
        setDuration(res.data.duration_minutes);
        setSelected(res.data.case_studies.map(cs => cs.id));
      });

    api.get(`/admin/case-study-practice/${id}/available-case-studies`)
      .then(res => setAllCaseStudies(res.data || []));
  }, [id]);

  const toggle = (csId) => {
    setSelected(prev =>
      prev.includes(csId)
        ? prev.filter(i => i !== csId)
        : [...prev, csId]
    );
  };

  const save = async () => {
    await api.put(`/admin/case-study-practice/${id}/update`, {
      title,
      duration_minutes: duration,
      case_study_ids: selected
    });

    alert("✅ Updated");
    nav(-1);
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Edit Case Study Practice</h2>

      <input value={title} onChange={e => setTitle(e.target.value)} />
      <input type="number" value={duration} onChange={e => setDuration(e.target.value)} />

      <h3>Select Case Studies</h3>

      {allCaseStudies.map(cs => (
        <label key={cs.id} style={{ display: "block" }}>
          <input
            type="checkbox"
            checked={selected.includes(cs.id)}
            onChange={() => toggle(cs.id)}
          />
          {cs.title}
        </label>
      ))}

      <button onClick={save}>💾 Save</button>
    </div>
  );
}
